import React from "react";
import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

interface CustomTooltipProps extends TooltipProps {
  /** Surface color; defaults to dashboard / sidebar neutral panels (not accent green). */
  color?: string;
}

/** Matches MyProSidebar tour card dark surface; dashboard KPI cards use ~#191c24 — same family. */
const TOOLTIP_BG_DARK = "#1f2933";

const CustomTooltip = styled(({ className, color, ...props }: CustomTooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, color }) => {
  const defaultBg =
    theme.palette.mode === "dark" ? TOOLTIP_BG_DARK : theme.palette.background.paper;
  const backgroundColor = color ?? defaultBg;
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor,
      color: theme.palette.getContrastText(backgroundColor),
      boxShadow: theme.palette.mode === "dark" ? theme.shadows[4] : theme.shadows[2],
      fontSize: 12,
      padding: 5,
      paddingLeft: 10,
      paddingRight: 10,
      border:
        theme.palette.mode === "light"
          ? "1px solid rgba(15, 23, 42, 0.08)"
          : undefined,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: backgroundColor,
    },
  };
});

export default CustomTooltip;
